import { I18n } from 'i18n-js';

const i18n = new I18n(document.__I18NJS.translations);

i18n.fallbacks = true;
i18n.defaultLocale = document.__I18NJS.defaultLocale;
i18n.locale = document.__I18NJS.locale;

export function translationListToKeyValues(translationList) {
  return Object.values(translationList).map((item) => {
    const key = Object.keys(item)[0];
    if (!item[key]) {
      return;
    }
    return { key: key, value: item[key] };
  });
}

export function translationListToSelectOptions(translationList) {
  return Object.values(translationList).map((item) => {
    const key = Object.keys(item)[0];
    if (!item[key]) {
      return;
    }
    return { value: key, label: item[key] };
  });
}

export function translationListToArray(translationList) {
  if (!Array.isArray(translationList)) {
    return;
  } // ensure we have an array otherwise strange things happen
  return Object.keys(translationList).map((key) => {
    return translationList[key];
  });
}

export function cityToI18nLocale(city) {
  if (city === 'new-york') {
    return 'en-new-york';
  }
  return 'en';
}

export default i18n;
